import { TAX_RATE_PERCENT_MAX } from "@/features/master-data/utils/taxRate";
import { TAX_CATEGORY, TTaxCategory } from "@/types/enum";
import { validator } from "@/utils/validator";

export const masterDataTaxRateSchema = validator.object().shape({
  taxRateSeries: validator.string().trim().emptyToNull().label("税率系列").required().max(50),
  displayName: validator.string().trim().emptyToNull().label("表示名").required().max(50),
  taxCategory: validator.string<TTaxCategory>().isSelection().emptyToNull().oneOf(Object.values(TAX_CATEGORY)).label("課税区分").required(),
  // 入力は % 単位（10 = 10%）。送信時に小数表記へ変換する
  ratePercent: validator.number().autoTransformToHalfWidth().emptyToNull().label("税率").required().min(0).max(TAX_RATE_PERCENT_MAX),
  effectiveFrom: validator.mixed().isSelection().isDayjs().label("適用開始日").required(),
  effectiveTo: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .isSameOrAfterDate("effectiveFrom", { startLabel: "適用開始日", endLabel: "適用終了日" })
    .label("適用終了日")
    .nullable(),
});
